import React, { useState, useEffect } from "react";
import PunishmentsPage from "./PunishmentsPage";
import NavBar from "./components/NavBar";
import HomePage from "./components/HomePage";
import MembersPage from "./components/MembersPage";
import { ThemeProvider } from "./components/ThemeContext";
import ActivityPage from './components/ActivityPage';
import darkBG from "../assets/darkBG.png";
import toast, { Toaster } from 'react-hot-toast';
import AuthPage from "./AuthPage";
import ChestPage from "./components/ChestPage";
import Cookies from "js-cookie";
import { useNavigate } from "react-router";
import StatsPage from "./components/StatsPage";
import CooldownsPage from "./components/CooldownsPage";

function MainPanel() {
  return (
    <ThemeProvider>
      <MainApp />
    </ThemeProvider>
  );
}

const MainApp = () => {
  const [currentPage, setCurrentPage] = useState(() => {
    return localStorage.getItem("currentPage") || "home";
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (
      Cookies.get("accountCreated") === "false" ||
      Cookies.get("email") === null ||
      Cookies.get("discordID") === null
    ) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    localStorage.setItem("currentPage", currentPage);
  }, [currentPage]);

  const renderPage = () => {
    switch (currentPage) {
      case "home":
        return <HomePage />;
      case "members":
        return <MembersPage />;
      case "activity":
        return <ActivityPage />;
      case "punishmentsList":
        return <PunishmentsPage />;
      case "treasury":
        return <ChestPage />;
      case "auth":
        return <AuthPage />;
      case "stats":
        return <StatsPage />
      case "cooldowns":
        return <CooldownsPage />;
      default:
        return <HomePage />;
    }
  };

  const appStyle: React.CSSProperties = {
    position: "absolute",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url(${darkBG})`,
  };

  return (
    <div className="dark" style={appStyle}>
      {currentPage !== "logout" && currentPage !== "auth" && (
        <NavBar setCurrentPage={setCurrentPage} />
      )}
      {renderPage()}
      <span className="absolute w-full text-center textMedium text-white bottom-[0.07vw] text-[0.7vw]">
        Copyright 2025 - Bogdan & Tristan
      </span>
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
    </div>
  );
};

export default MainPanel;